import type { Run } from '../api/client'
import { qualityCellState } from '../utils/qualityCellState'

/**
 * The quality column for the run tables — the SCORE, coloured from the STORED SLA verdict.
 *
 * ONE COMPONENT, TWO PAGES, for the reason stated at the top of `SlaCell.tsx`: the cell it
 * replaces was hand-written in both `RunHistory` and `GlobalRunHistory` and both copies carried
 * the same defect — they rendered `quality_result` (an OCR readability enum) coloured
 * green/amber/red and consulted no threshold at all, in a column read as the quality SLA.
 *
 * THE RULE LIVES IN `utils/qualityCellState.ts` and is executed by
 * `tests/test_quality_column_shows_the_score.py`. This file is presentation only: it maps a
 * TONE onto the palette. Nothing here decides a verdict, and in particular nothing compares a
 * score against a threshold.
 */

// The same three the SLA cell uses, so one row cannot say "pass" in two different greens.
const RED = '#f44336'
const GREEN = '#4caf50'
const GREY = '#9aa0a6'

const TONE_COLOUR = { good: GREEN, bad: RED, neutral: GREY } as const

export function QualityCell({ run }: { run: Run }) {
  const state = qualityCellState(run)
  return (
    <span
      title={state.title}
      style={{
        color: TONE_COLOUR[state.tone],
        fontWeight: state.tone === 'bad' ? 700 : 500,
        fontSize: '0.85rem',
        cursor: 'help',
        whiteSpace: 'nowrap',
      }}
    >
      {state.label}
      {state.aggregate && (
        <span style={{ color: GREY, fontSize: '0.7rem', marginLeft: '0.3rem' }}>agg</span>
      )}
    </span>
  )
}
